<script setup lang="ts">
import { getTagDatasource } from '@/data/tag';
import LetButton from '@/letapps-vue/components/LetButton.vue';
import { DxButton } from 'devextreme-vue/button';
import { DxForm, DxLabel, DxSimpleItem } from 'devextreme-vue/form';
import { DxItem, DxToolbar } from 'devextreme-vue/toolbar';
import { confirm } from 'devextreme/ui/dialog';
import { ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  tagId: {
    type: Number,
    required: false,
  },
});

const tagDatasource = getTagDatasource();

const tag = ref();
const loading = ref(false);

async function gemTag() {
  loading.value = true;

  try {
    await tagDatasource.save(tag.value);
  } catch (e) {
    console.error(e);
  }

  loading.value = false;
  await router.push('/admin/tags');
}

async function sletTag() {
  let result = confirm(
    'Er du sikker på, at du vil slette <b>' + tag.value.navn + '</b>?',
    'Slet tag',
  );
  result.then(async (answer) => {
    if (answer) {
      await tagDatasource.store().remove(tag.value.id);
      await router.push('/admin/tags');
    }
  });
}

async function fortryd() {
  if (props.tagId && props.tagId > 0) tag.value = await tagDatasource.store().byKey(props.tagId);
  await router.back();
}

watchEffect(async () => {
  if (props.tagId && props.tagId > 0) {
    tag.value = await tagDatasource.store().byKey(props.tagId);
  } else {
    tag.value = {};
  }
});
</script>

<template>
  <div v-if="tag">
    <div class="container">
      <div class="left">
        <DxForm :form-data="tag" :showValidationSummary="true">
          <DxSimpleItem data-field="navn" />

          <DxSimpleItem>
            <DxLabel text=" " :showColon="false" />
            <DxToolbar>
              <DxItem location="before">
                <LetButton
                  :loading="loading"
                  text="Gem tag"
                  :use-submit-behavior="false"
                  @click="gemTag"
                  type="default"
                />
              </DxItem>
              <DxItem location="before">
                <DxButton text="Fortryd" @click="fortryd" />
              </DxItem>
              <DxItem location="after">
                <DxButton
                  text="Slet tag"
                  v-if="tagId && tagId > 0"
                  @click="sletTag"
                  type="danger"
                  styling-mode="outlined"
                />
              </DxItem>
            </DxToolbar>
          </DxSimpleItem>
        </DxForm>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/css//variables.letguide.scss';

.container {
  display: flex;
  gap: 20px;
}

.left {
  flex: 1;
  max-width: 800px;
}

.right {
  width: 500px;
  padding-left: 20px;
  background-color: $letpension-sand-light;
}
</style>
